import type { AgentChatSessionSummary } from '@/frontend/pages/Dashboard/AgentChats/types'

// Published meeting preparations must not need a fake human kickoff. This
// predicate only controls an already-authorized summary's list visibility.
export function hasHistoryContent(session: AgentChatSessionSummary, activeSessionId: string | null) {
  return session.has_visible_user_message || session.has_visible_preparation ||
    session.business_process_edit || session.id === activeSessionId
}
